PreventSecondClick.DIRECTIVE_NAME = 'ktPreventSecondClick';

export default function PreventSecondClick($timeout) {
    'ngInject';

    const delay = 300;
    return {
        restrict: 'A',
        priority: 1,
        link: function($scope, $elem) {
            let disabled = false;
            const invokeApply = false;

            function onClick(event) {
                if (disabled) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                } else {
                    disabled = true;
                    $timeout(() => disabled = false, delay, invokeApply);
                }
            }

            $elem.on('click', onClick);
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/directives/prevent-second-click.js